import { Switch } from '@vnetwork/ui/primitives';
import { Alert } from '@vnetwork/ui/feedback';
import { Field } from '@vnetwork/ui/forms';
import type { DomainDraft } from './wizard-types';

/**
 * Step 4 — WAF (Web Application Firewall).
 *
 * The toggle defaults ON so every new domain starts protected with managed OWASP
 * rules. This step is only the master switch: enforcement mode (Monitor vs
 * Block), bot management and AI rules live in the domain's Security → WAF tab —
 * the wizard doesn't set them, so it must not promise a specific mode here.
 */
export function StepWaf({
  draft,
  set,
}: {
  draft: DomainDraft;
  set: (patch: Partial<DomainDraft>) => void;
}) {
  return (
    <>
      <Field
        label="Web Application Firewall"
        description="Managed OWASP rules, bot and DDoS protection, on by default."
        orientation="horizontal"
      >
        {(props) => (
          <Switch
            id={props.id}
            aria-describedby={props['aria-describedby']}
            checked={draft.wafEnabled}
            onCheckedChange={(v) => set({ wafEnabled: v })}
          />
        )}
      </Field>

      {draft.wafEnabled && (
        <Alert tone="info">
          WAF is enabled with managed OWASP rules. Fine-tune the enforcement mode, bot and AI
          rules anytime from the domain's Security → WAF tab.
        </Alert>
      )}
    </>
  );
}
